<template>
	<PointsHistoryDialog v-model="open" :overlay-target="overlayTarget" />
</template>

<script setup>
import { ref, inject, onMounted, onBeforeUnmount } from 'vue';
import PointsHistoryDialog from './PointsHistoryDialog.vue';

const overlayTarget = inject('overlayTarget', null);
const open = ref(false);

function handleOpen() {
	open.value = true;
}

onMounted(() => {
	window.addEventListener('open-vue-points-dialog', handleOpen);
});

onBeforeUnmount(() => {
	window.removeEventListener('open-vue-points-dialog', handleOpen);
});
</script>
